import React from 'react';
import { Select, Input, Form, Header, Segment, Grid } from 'semantic-ui-react';

export default class ParentsInfoForm extends React.PureComponent {
    render() {
        return (

            <Grid columns={2} className="stackable">
                <Grid.Column>
                    <Form>
                        <Form.Field
                            control={Input}
                            label="Ime oca"
                            placeholder="Ime"
                            value={this.props.fatherFirstName}
                            onChange={this.props.onChange}
                            name="fatherFirstName"
                        />
                        <Form.Field
                            control={Input}
                            label="Prezime oca"
                            placeholder="Prezime"
                            value={this.props.fatherLastName}
                            onChange={this.props.onChange}
                            name="fatherLastName"
                        />

                        <Form.Field
                            control={Select}
                            clearable
                            label="Status u aktivnosti oca"
                            options={this.props.activityStatusTypes}
                            placeholder="Status u aktivnosti"
                            onChange={this.props.handleInputChange}
                            name="activityStatusTypeF"
                            value={this.props.activityStatusTypeF}
                        />

                        <Form.Field
                            disabled={this.props.activityStatusTypeF !== this.props.activeStatusId}
                            control={Input}
                            label="Zanimanje oca"
                            placeholder="Zanimanje"
                            value={this.props.occupationF}
                            onChange={this.props.handleInputChange}
                            name="occupationF"
                        />
                        <Form.Field
                            required
                            disabled={this.props.activityStatusTypeF !== this.props.activeStatusId}
                            control={Select}
                            clearable
                            label="Status zanimanja oca"
                            options={this.props.occupationStatuses}
                            placeholder="Status zanimanja"
                            onChange={this.props.handleInputChange}
                            name="occupationStatusF"
                            value={this.props.occupationStatusF}
                        />
                    </Form>
                </Grid.Column>
                <Grid.Column>
                    <Form>
                        <Form.Field
                            control={Input}
                            label="Ime majke"
                            placeholder="Ime"
                            value={this.props.motherFirstName}
                            onChange={this.props.onChange}
                            name="motherFirstName"
                        />
                        <Form.Field
                            control={Input}
                            label="Prezime majke"
                            placeholder="Prezime"
                            value={this.props.motherLastName}
                            onChange={this.props.onChange}
                            name="motherLastName"
                        />

                        <Form.Field
                            control={Select}
                            clearable
                            label="Status u aktivnosti majke"
                            options={this.props.activityStatusTypes}
                            placeholder="Status u aktivnosti"
                            onChange={this.props.handleInputChange}
                            name="activityStatusTypeM"
                            value={this.props.activityStatusTypeM}
                        />

                        <Form.Field
                            disabled={this.props.activityStatusTypeM !== this.props.activeStatusId}
                            control={Input}
                            label="Zanimanje majke"
                            placeholder="Zanimanje"
                            value={this.props.occupationM}
                            onChange={this.props.handleInputChange}
                            name="occupationM"
                        />
                        <Form.Field
                            required
                            disabled={this.props.activityStatusTypeM !== this.props.activeStatusId}
                            control={Select}
                            clearable
                            label="Status zanimanja majke"
                            options={this.props.occupationStatuses}
                            placeholder="Status zanimanja"
                            onChange={this.props.handleInputChange}
                            name="occupationStatusM"
                            value={this.props.occupationStatusM}
                        />
                    </Form>
                </Grid.Column>

            </Grid>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentCreateAndEdit/FormParts/ParentsInfoForm.js